import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { ChartTotalItems } from '~/modules/common/charts/timeline/components';
import RowTotalCost from '~/modules/resourcing/components/RowTotalCost';
import RowTotalHours from '~/modules/resourcing/components/RowTotalHours';
import { FormattedHoursAndCost } from '~/modules/resourcing/common/components';

const useStyles = makeStyles(theme => ({
  hours: {
    fontWeight: theme.typography.fontWeightBold
  },
  cost: {
    fontWeight: theme.typography.fontWeightBold
  }
}));

export const ResourcePlanTotal = ({
  classes: classesOverrides,
  totalHours,
  totalCost,
  tooltipTotalCost = totalCost,
  qeIdTag,
  hideCosts = false
}) => {
  const classes = useStyles({ classes: classesOverrides });

  const allocatedCost = totalCost.map(c => ({
    amount: c.allocatedAmount,
    currencySymbol: c.currencySymbol
  }));

  const plannedCost = totalCost.map(c => ({
    amount: c.requestedAmount,
    currencySymbol: c.currencySymbol
  }));

  const requested = useMemo(
    () => (
      <FormattedHoursAndCost
        hours={totalHours.requestedHours}
        costs={plannedCost}
        hideCosts={hideCosts}
        showAbbreviatedValue={false}
      />
    ),
    [hideCosts, plannedCost, totalHours.requestedHours]
  );

  const allocated = useMemo(
    () => (
      <FormattedHoursAndCost
        classes={classes}
        hours={totalHours.allocatedHours}
        costs={allocatedCost}
        hideCosts={hideCosts}
        showAbbreviatedValue={false}
      />
    ),
    [allocatedCost, classes, hideCosts, totalHours.allocatedHours]
  );

  const tooltipAllocatedCost = tooltipTotalCost.map(c => ({
    amount: c.allocatedAmount,
    currencySymbol: c.currencySymbol
  }));

  const tooltipPlannedCost = tooltipTotalCost.map(c => ({
    amount: c.requestedAmount,
    currencySymbol: c.currencySymbol
  }));

  const tooltip = useMemo(
    () =>
      hideCosts ? (
        <RowTotalHours
          showAbbreviatedValue={false}
          plannedHours={totalHours.requestedHours}
          allocatedHours={totalHours.allocatedHours}
        />
      ) : (
        <>
          <RowTotalHours
            showAbbreviatedValue={false}
            plannedHours={totalHours.requestedHours}
            allocatedHours={totalHours.allocatedHours}
          />
          &nbsp;
          <RowTotalCost
            showAbbreviatedValue={false}
            plannedCost={tooltipPlannedCost}
            allocatedCost={tooltipAllocatedCost}
          />
        </>
      ),
    [
      tooltipAllocatedCost,
      hideCosts,
      tooltipPlannedCost,
      totalHours.allocatedHours,
      totalHours.requestedHours
    ]
  );

  return (
    <ChartTotalItems
      qeIdTag={qeIdTag}
      requested={requested}
      allocated={allocated}
      title={tooltip}
    />
  );
};

ResourcePlanTotal.propTypes = {
  qeIdTag: PropTypes.string,
  classes: PropTypes.object,
  totalHours: PropTypes.object.isRequired,
  totalCost: PropTypes.array.isRequired,
  tooltipTotalCost: PropTypes.array,
  hideCosts: PropTypes.bool
};

export default ResourcePlanTotal;
